import { Formio } from '@formio/js';
import bootstrap4 from '@formio/bootstrap/bootstrap4';
import { ScwESignatureComponent } from './formio-components/signature/scw-signature.formio';
import { ScwRoleCheckerComponent } from './formio-components/role-checker/scw-role-checker.formio';

let registered = false;

export function registerFormioComponents(): void {
  if (registered) {
    return;
  }

  (Formio as any).use(bootstrap4);

  (Formio as any).use({
    components: {
      scwESignature: ScwESignatureComponent,
      scwRoleChecker: ScwRoleCheckerComponent,
    },
  });

  registered = true;
}
